import * as ko from "knockout";

// Models
import StandardButtonsBase, { IStandardButtonsBase } from 'Content/ts/Shared/Buttons/StandardButtons/StandardButtonsBase';

export default class ButtonInverse extends StandardButtonsBase {
    constructor(params: IStandardButtonsBase) {
        super(params);
    }
}

const buttonInverseGrey = "button-inverse";
ko.components.unregister(buttonInverseGrey);
ko.components.register(buttonInverseGrey, {
    viewModel: ButtonInverse,
    template: { require: `text!Content/ts/Shared/Buttons/StandardButtons/Inverse/${buttonInverseGrey}.html` }
});

const buttonInverseWhite = "button-inverse-white"
ko.components.unregister(buttonInverseWhite);
ko.components.register(buttonInverseWhite, {
    viewModel: ButtonInverse,
    template: { require: `text!Content/ts/Shared/Buttons/StandardButtons/Inverse/${buttonInverseWhite}.html` }
});